import { BiCheck, BiX } from "react-icons/bi";
import styled from "styled-components";
import * as yup from "yup";

import { formatCurrency } from "util/numbers";

import {
  ColorSlider,
  DisplayInput,
  FieldContainer,
  FlexButton,
  FlexButtonContainer,
  TextInput,
  FileInput,
  ButtonType,
} from "components/ui/forms";
import { useStore } from "hooks";
import { Account } from "api/types/Account";
import { useMutation } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;
const Label = styled.div`
  width: 30%;
  font-size: 0.6rem;
  padding: 0 1rem;
`;

const validation = yup.object().shape({
  account: yup
    .object()
    .shape({
      id: yup.string().required(),
      name: yup.string(),
    })
    .required(),
  delimiter: yup.string().required(),
  file: yup.mixed().required("File is required"),
});

export type Import = {
  account: Account;
  delimiter: string;
  file: File;
};

type Props = {
  data: Partial<Import>;
  onSubmit: (data: Import) => void;
  onCancel: () => void;
  onAccountClick?: () => void;
  onFileChange?: (file: File) => void;
  onDelimiterChange?: (delimiter: string) => void;
};

const ImportForm = ({
  data,
  onSubmit,
  onAccountClick,
  onFileChange,
  onDelimiterChange,
  onCancel,
}: Props) => {
  const handleSubmit = () => {
    try {
      const validatedData = validation.validateSync(data, {
        abortEarly: false,
      });
      onSubmit(validatedData);
    } catch (errors) {
      console.log(errors);
      // setErrors(getKeyedValidationErrors(errors))
    }
  };

  const canSubmit = useMemo(() => {
    try {
      validation.validateSync(data);
    } catch (errors) {
      return false;
    }
    return true;
  }, [data]);

  return (
    <Container>
      <div>
        <FieldContainer>
          <DisplayInput
            name="account"
            label="Account"
            placeholder="Select ..."
            onClick={onAccountClick}
            value={data.account ? data.account.id : ""}
            display={data.account ? data.account.name : ""}
          />
        </FieldContainer>

        <FieldContainer>
          <TextInput
            label="Delimiter ..."
            placeholder="Delimiter ..."
            defaultValue={data.delimiter}
            onChange={onDelimiterChange}
          />
        </FieldContainer>

        <FieldContainer>
          <FileInput label="Import Transactions" onChange={onFileChange} />
        </FieldContainer>
      </div>

      <FlexButtonContainer>
        <FlexButton onClick={onCancel} type={ButtonType.Cancel}>
          <BiX />
        </FlexButton>
        <FlexButton
          onClick={handleSubmit}
          disabled={!canSubmit}
          type={ButtonType.Accept}
        >
          <BiCheck />
        </FlexButton>
      </FlexButtonContainer>
    </Container>
  );
};

export default ImportForm;
